import { Link } from 'react-router'
import classNames from 'classnames'

import { Lockup } from '@/assets'
import useBreakpoints from '@/hooks/useBreakpoints'

interface BrandProps {
  className?: string;
  styles?: React.CSSProperties;
}

function Brand({ className, styles }: BrandProps) {
  const { isTablet, isMobile } = useBreakpoints()

  return (
    <Link
      className={classNames('brand', className)}
      to='/'
      style={{ lineHeight: 0 }}
    >
      <Lockup
        style={{
          maxWidth: isMobile ? 164 : isTablet ? 186 : 240,
          width: '80%',
          ...styles
        }} />
    </Link>
  )
}

export default Brand
